// Voucher documentation is persisted independently from financial edits.
const uploadVoucherAttachment = async (voucher, fileOrFiles) => {
  const ok = await initFirebase();
  if (!ok || !runtime.db || !runtime.auth?.currentUser) {
    throw new Error(t('svc.backendNotConfigured'));
  }
  const files = fileOrFiles instanceof File ? [fileOrFiles] : Array.from(fileOrFiles || []); if (!files.length || files.some((file) => !(file instanceof File))) throw new Error(t('svc.pickFileFirst'));
  const resolved = resolveBackendVoucher(voucher);
  if (!resolved?.sourceType || !resolved?.source?.id) throw new Error(t('svc.missingVoucherForAttachment'));
  const ownerType = resolved.sourceType === 'invoice'
    ? 'invoices'
    : resolved.sourceType === 'otherSale'
      ? 'other-sales'
      : 'expenses';
  const uploadedDocument = await uploadEditorAttachments(resolved.source, files.map((file) => ({ file, name: file.name, type: file.type })), ownerType);
  const primaryAttachment = safeArray(uploadedDocument.attachments)[0];
  const nextDocument = primaryAttachment
    ? stripUndefinedDeep({
        ...uploadedDocument,
        attachmentId: uploadedDocument.attachmentId || primaryAttachment.id,
        attachmentName: uploadedDocument.attachmentName || primaryAttachment.name,
        attachmentMimeType: uploadedDocument.attachmentMimeType || primaryAttachment.mimeType,
        attachmentStatus: undefined,
        attachmentMissingReason: undefined,
        attachmentMissingMarkedAt: undefined,
      })
    : uploadedDocument;
  if (resolved.sourceType === 'invoice') {
    await replaceInvoiceAndPersist(nextDocument);
  } else if (resolved.sourceType === 'otherSale') {
    await upsertOtherSale(nextDocument);
  } else if (nextDocument.manualPosting === true) {
    const result = await authorizedPost('manualPostingMutationHttp', {
      businessId: runtime.activeBusinessId,
      action: 'upsert',
      postings: [nextDocument],
    });
    if (result?.state) {
      runtime.appState = mergeAppMutationState(result.state);
      emitRuntime();
    }
  } else {
    const previousPaths = new Set(safeArray(resolved.source.attachments).map((entry) => entry.storagePath));
    const result = await authorizedPost('purchaseMutationHttp', {
      businessId: runtime.activeBusinessId,
      action: 'add_attachments',
      expenseId: resolved.source.id,
      expense: { attachments: safeArray(nextDocument.attachments).filter((entry) => !previousPaths.has(entry.storagePath)) },
    });
    if (result?.state) {
      runtime.appState = mergeAppMutationState(result.state);
      emitRuntime();
    }
  }
  window.dispatchEvent(new Event(BACKEND_EVENTS.state));
  return nextDocument;
};
